module.exports = __webpack_public_path__ + "img/42.1709fd61.jpg";